import { SubpageIntro2018, SubpageLayout2018 } from './subpageLayout';

type Winner = { company: string; award: string };
type WinnerCategory = {
  key: 'mobility' | 'living' | 'environment' | 'people' | 'government' | 'economy';
  title: string;
  tab: string;
  icon: string;
  winners: Winner[];
};

const categories: WinnerCategory[] = [
  {
    key: 'mobility',
    title: 'Hong Kong Smart City Awards 2018 in Smart Mobility',
    tab: 'Hong Kong Smart City Awards 2018 in Smart Mobility',
    icon: '/2018/images/mobility.png',
    winners: [
      { company: 'Airport Authority Hong Kong', award: 'Outstanding International Airport App' },
      { company: 'CamClaim Ltd', award: 'Outstanding Mobile Payment Platform in Business' },
      { company: 'GreenSafety Technology Limited', award: 'Outstanding Cloud-based Fleet Management System' },
      { company: 'Hong Kong Applied Science and Technology Research Institute Company Limited', award: 'Outstanding Internet of Vehicles (IoV) Management System' },
      { company: 'Hong Kong Electric Vehicle Network Limited', award: 'Outstanding Portable Electric Vehicle Charger' },
      { company: 'Infineon Technologies Hong Kong Limited', award: 'Outstanding Smart Street Lighting System' },
      { company: 'IngDan Technology (Hong Kong) Limited', award: 'Outstanding Smart Driver Assistance System' },
      { company: 'Logistics and Supply Chain MultiTech R&D Centre', award: 'Outstanding Differential GPS for Outdoor Positioning' },
      { company: 'NEC Hong Kong Limited', award: 'Outstanding Smart Traffic Management Solution' },
      { company: 'oneCHARGE Solutions Limited', award: 'Outstanding Smart Electric Vehicle Charging System' },
      { company: 'SagaDigits Limited', award: 'Outstanding Smart Retail Integrated Customer Data Promotion Solutions' },
      { company: 'Smart Charge (HK) Limited', award: 'Outstanding One-stop Electric Vehicle Charging Solutions' },
      { company: 'WildFaces Technology Limited', award: 'Outstanding Smart Recognition and Tracking System' },
    ],
  },
  {
    key: 'living',
    title: 'Hong Kong Smart City Awards 2018 in Smart Living',
    tab: 'Hong Kong Smart City Awards 2018 in Smart Living',
    icon: '/2018/images/living.png',
    winners: [
      { company: 'AXA Hong Kong', award: 'Outstanding InsurTech Innovation (Customer Experience)' },
      { company: 'China Mobile Hong Kong Company Limited', award: 'Outstanding Greater Bay Area Mobile Network Service Provider' },
      { company: 'Computime Group Limited', award: 'Outstanding Internet of Things (IoT) Solution for Smart Comfort' },
      { company: 'Dr Care', award: 'Outstanding AI-powered Medical Service' },
      { company: 'Dragon Creative Enterprise Solution Limited', award: 'Outstanding Smart Glasses with AR Technology' },
      { company: 'Health View Bioanalytic Limited', award: 'Outstanding Asessment of Health Data Analysis Program' },
      { company: 'HKT Payment Limited (Tap & Go)', award: 'Outstanding Mobile Payment App' },
      { company: 'HKT Smart Living', award: 'Outstanding Smart Living Solutions' },
      { company: 'Hospital Authority', award: 'Outstanding Clinical Management System' },
      { company: 'iBonus Limited', award: 'Outstanding Offline Mobile Prepaid System' },
      { company: 'Logistics and Supply Chain MultiTech R&D Centre', award: 'Outstanding RFID Blind Cane System' },
      { company: 'NEC Hong Kong Limited', award: 'Outstanding Smart Lifestyle Centred Solution' },
      { company: 'Polydigi Limited', award: 'Outstanding Network Security Authentication System' },
      { company: 'Sanomics Limited', award: 'Outstanding Cancer Genomics Liquid Biopsy Technology' },
    ],
  },
  {
    key: 'environment',
    title: 'Hong Kong Smart City Awards 2018 in Smart Environment',
    tab: 'Hong Kong Smart City Awards 2018 in Smart Environment',
    icon: '/2018/images/environment.png',
    winners: [
      { company: 'Carbon World Limited', award: 'Outstanding Internet of Things (IoT) for Energy Coin Incentive-driven Platform' },
      { company: 'Hawkeyes Solutions Limited', award: 'Outstanding Landslide Detection System' },
      { company: 'Hong Kong Applied Science and Technology Research Institute Company Limited', award: 'Outstanding Internet of Things (IoT) for Smart Water Management' },
      { company: 'KDK Labs Limited', award: 'Outstanding Smart Waste Management System' },
      { company: 'Logistics and Supply Chain MultiTech R&D Centre', award: 'Outstanding DGNSS for Tracking System' },
    ],
  },
  {
    key: 'people',
    title: 'Hong Kong Smart City Awards 2018 in Smart People',
    tab: 'Hong Kong Smart City Awards 2018 in Smart People',
    icon: '/2018/images/people.png',
    winners: [
      { company: 'Fano Labs Limited', award: 'Outstanding AI in Speech Recognition for Business Solutions' },
      { company: 'Find Solution AI Limited', award: 'Outstanding AI Learning Application' },
      { company: 'KeyChain FinTech Limited', award: 'Outstanding Smart Rental Payment Platform' },
      { company: 'NEC Hong Kong Limited', award: 'Outstanding Face Recognition Solution' },
      { company: "St. Paul's Convent School", award: 'Outstanding STEM Education School' },
    ],
  },
  {
    key: 'government',
    title: 'Hong Kong Smart City Awards 2018 in Smart Government',
    tab: 'Hong Kong Smart City Awards 2018 in Smart Government',
    icon: '/2018/images/government.png',
    winners: [
      { company: 'Blockchain Solutions Ltd.', award: 'Outstanding Innovation in Blockchain Technological Solutions' },
      { company: 'Inspiring Light Electronics Software Development Limited', award: 'Outstanding Internet of Things (IoT) for Smart Pole Portal Management' },
      { company: 'Logistics and Supply Chain MultiTech R&D Centre', award: 'Outstanding Smart Drainage System' },
      { company: 'NEC Hong Kong Limited', award: 'Outstanding Image Analysis Solution' },
    ],
  },
  {
    key: 'economy',
    title: 'Hong Kong Smart City Awards 2018 in Smart Economy',
    tab: 'Hong Kong Smart City Awards 2018 in Smart Economy',
    icon: '/2018/images/economy.png',
    winners: [
      { company: 'Airbare.com Limited', award: 'Outstanding Online Air Fare Aggregator' },
      { company: 'Animae Technologies Limited', award: 'Outstanding Smart Digital Stamp App' },
      { company: 'AsiaPay', award: 'Outstanding Online Payment Gateway' },
      { company: 'Canon Hongkong Co., Ltd.', award: 'Outstanding Cloud-based and Mobile Working Platform' },
      { company: 'Dah Sing Bank, Ltd', award: 'Outstanding SME Online Virtual Banking Service Centre' },
      { company: 'DHL Express Hong Kong', award: 'Outstanding Online On-Demand Delivery Service' },
      { company: 'eAgent', award: 'Outstanding Real Estate Mobile App' },
      { company: 'Eatigo Hong Kong Limited', award: 'Outstanding Online Restaurant Reservations Platform' },
      { company: 'Eats365 Hong Kong Limited', award: 'Outstanding Cloud-based Catering Management Platform' },
      { company: 'EFT Solutions Limited', award: 'Outstanding Electronic Payment Solutions' },
      { company: 'Hong Kong Applied Science and Technology Research Institute Company Limited', award: 'Outstanding Text Correction System on Mobile Devices' },
      { company: 'JOS', award: 'Outstanding Smart Retail Solutions' },
      { company: 'Logistics and Supply Chain MultiTech R&D Centre', award: 'Outstanding "Follow Me" Robots Technology' },
      { company: 'OpenVR.shop - Wee Creation Company Limited', award: 'Outstanding VR eCommerce Platform' },
      { company: 'Ricacorp Properties Limited', award: 'Outstanding Artificial Intelligence Properties Platform' },
      { company: 'UC Now Communication Limited', award: 'Outstanding Multimedia Communication Solutions' },
      { company: 'Wesurance Limited', award: 'Outstanding Insurance Technology in Development and Application Platform' },
    ],
  },
];

export default function Winners2018() {
  return (
    <SubpageLayout2018 lang="en" title="Winners" page="winners">
      <div className="award_categories">
        <SubpageIntro2018 heading="Winners" />
        <div className="winners_list_wrapper">
          <div className="winners_list_container">
            <div className="col-left">
              <div className="winners_cate_nav" id="winners_cate_nav">
                <ul className="tabs">
                  {categories.map((c, idx) => (
                    <li key={c.key} className={`anchorlink nav_${c.key}${idx === 0 ? ' current_mobility' : ''}`} id={`winner_${c.key}`}>
                      <a className={idx === 0 ? 'color' : undefined} href={`#company_list_${c.key}`}>
                        <img src={c.icon} alt="" />
                        <div className="tabs_text">{c.tab}</div>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-right">
              <div className="company_list_container">
                <div className="company_list">
                  {categories.map((c) => (
                    <div key={c.key} id={`company_list_${c.key}`} className={`company_list_${c.key} target`}>
                      <ul className="companies">
                        <li className="award_title">{c.title}</li>
                        <br />
                        {c.winners.map((w) => (
                          <div key={`${c.key}-${w.company}`}>
                            <li className="award_company_name">{w.company}</li>
                            <li className="award_name">{w.award}</li>
                            <br />
                          </div>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

